module.exports = __webpack_public_path__ + "img/11.68ef953b.jpg";